import React from "react"

const Star = ({classname,color})=>{
    return(
        <svg 
        width="17" 
        height="17" 
        viewBox="0 0 17 17" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
        style={{fill: color}}
        className={classname}
        >
            <path d="M8.01736 12.6733L3.31536 15.3053L4.36536 10.02L0.408691 6.36131L5.76002 5.72665L8.01736 0.833313L10.2747 5.72665L15.626 6.36131L11.6694 10.02L12.7194 15.3053L8.01736 12.6733Z" fill
            />
        </svg>

    )
}
export default Star
